export default {
  install(Vue) {
    Vue.prototype.get_recruitment_method = async function() {
      const api = `${window.endpoints.api}/BasicInformation/RecruitmentMethod`;
      const params = { IsEnable: true };

      const response = await this.$http.get(api, { params });
      const sorted = response.data.sort((a, b) => a.Seq - b.Seq);

      return sorted;
    };
  },
};